import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/es/reduxForm';
import validator from 'validator';
import { getUserSession, updateCustomerEmail } from 'actions/authentication';
import history from 'router/history';
import { keyErrorsFieldRequired } from 'utils/helpers';
import Welcome from 'components/Credit24/Common/CustomerMigrationAU/Welcome';
import ThankYou from 'components/Credit24/Common/CustomerMigrationAU/ThankYou';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  getUserSession: PropTypes.func.isRequired,
  updateCustomerEmail: PropTypes.func.isRequired,
};

class CustomerMigrationAUContainer extends Component {
  constructor() {
    super();
    this.state = { migrationDone: false, error: false };
    this.onSubmit = this.onSubmit.bind(this);
    this.verifyIdentificationState = this.verifyIdentificationState.bind(this);
  }

  componentDidMount() {
    this.verifyIdentificationState();
  }

  componentDidUpdate() {
    this.verifyIdentificationState();
  }

  onSubmit(data) {
    if (this.state.migrationDone) {
      this.props.getUserSession(true);
    } else {
      const { email } = data;
      this.props.updateCustomerEmail(
        email,
        (result) => {
          if (result === 'NEW_REQUEST_CREATED' || result === 'SAME_EMAIL_REPEAT_EMAIL_SEND') {
            this.setState(
              {
                email: data.email,
                migrationDone: true,
              },
              () => {
                window.scrollTo(0, 0);
              }
            );
          } else {
            this.setState({ error: true });
          }
        }
      );
    }
  }

  verifyIdentificationState() {
    const { authentication: { identificationState } } = this.props;
    if (identificationState && identificationState !== 'NOT_STARTED_YET') {
      let path;
      if (SELF_SERVICE) {
        path = '/';
      } else {
        path = `/loan${location.search}${location.hash}`;
      }
      history.replace(path);
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { authentication, handleSubmit } = this.props;

    if (!authentication.identificationState) {
      return <span />;
    }

    let content;
    if (this.state.migrationDone) {
      content = (
        <ThankYou
          isLoading={authentication.isLoading}
          email={this.state.email}
        />
      );
    } else {
      content = (
        <Welcome
          isLoading={authentication.isLoading}
          migrationFailed={this.state.error}
        />
      );
    }

    return (
      <div className="container container--mobile-fullWidth">
        <form className="loan-form" onSubmit={handleSubmit(this.onSubmit)}>
          {content}
        </form>
      </div>
    );
  }
}

CustomerMigrationAUContainer.propTypes = propTypes;

const migrationFormConfig = {
  form: 'migrationForm',
  validate: ({ email, emailConfirm }) => {
    const errors = {};
    if (!email) {
      errors.email = keyErrorsFieldRequired;
    } else if (!validator.isEmail(email)) {
      errors.email = 'errors.field.email';
    }
    if (!emailConfirm || emailConfirm !== email) {
      errors.emailConfirm = 'errors.field.emailConfirm';
    }
    return errors;
  },
  onSubmitFail: (errors, dispatch, submitErrors) => {
    if (DEBUG) {
      console.warn('form submit fail', errors, submitErrors);
    }
  },
};

export default connect(
  (state) => ({
    initialValues: {
      email: state.authentication.email || state.authentication.emailPending,
    },
    authentication: state.authentication,
  }),
  { getUserSession, updateCustomerEmail }
)(reduxForm(migrationFormConfig)(CustomerMigrationAUContainer));
